import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import Paper from "@material-ui/core/Paper";
import Toolbar from "@material-ui/core/Toolbar";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import IconButton from "@material-ui/core/IconButton";
import AppBar from "@material-ui/core/AppBar";
import getData from "./../../data-services/api";
import Loader from "./../../components/CustomLoader";
import client from "./../../utils/apolloClient";
import { getUser } from "./../../data-services/queries";
import PersonPinIcon from "@material-ui/icons/PersonPin";
import Divider  from "@material-ui/core/Divider";
import Select from 'react-select';
import filterImage from "./../FCP/images/filterImage.png";
import gql from "graphql-tag";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import SwipeableViews from "react-swipeable-views";
import Execution from "../../images/settings.png";
import Waiting from "../../images/wait.png";
import Planning from "../../images/writing.png";
import Confirm from "../../images/confirm.png";
import Verified from "../../images/verified.png";
import Cancelled from "../../images/prohibition.png";

import _ from "lodash"
const styles = theme => ({
  fab: {
    //margin: theme.spacing.unit,
    right: 0,
    bottom: 0,
    position: "fixed",
    margin: "20px"
  },
  extendedIcon: {
    marginRight: theme.spacing.unit
  }
});

const RederWorkshopList = withRouter(props => {
  console.log("filter State => ", props.filterState)
  const { classes, history, workshops, filterState } = props;
  const {cmdiFilter, fcpFilter, stageFilter} = filterState;
  return (
    <List >
    {workshops ? (
      workshops.map(workshop => {             
          return (            
              <Paper
                elevation={2}
                style={{ padding: 5}}
                key={workshop.id}
                // square={true}
                onClick={() => {
                  history.push({
                    pathname: "/workshop", 
                    state: {cmdiFilter, fcpFilter, stageFilter},
                    // id, workshopSFID, source, stagename
                    search: `?id=${workshop.id}&workshopSFID=${
                      workshop.sfid
                      }&source='listWorkshopsAMMD'&stagename=${
                      workshop.stagename
                      }`
                  });
                }}
              >
                <Grid container spacing={8} alignItems="center">
                  <Grid item xs={5} style={{ paddingLeft: 10 }}>
                    <Typography
                      align="left"
                      variant="body2"
                      component=""
                    >
                      {workshop.name}
                    </Typography>
                    <Typography
                      align="left"
                      variant="caption"
                      component="p"
                    >
                      {workshop.start_date_time__c}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography align="left" variant="body1">
                      {workshop.cmdi_name__c}
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography align="left" variant="body1">
                      {workshop.fcpname__c}
                    </Typography>
                  <Typography align="left">
                      {workshop.stagename}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography align="left">
                      {workshop.stagename === "Planning" &&
                        <img src={Planning} style={{ width: '30px', paddingLeft: '10px' }} />
                      }
                      {workshop.stagename === "Awaiting Workshop Confirmation" &&
                        <img src={Waiting} style={{ width: '30px', paddingLeft: '10px' }} />
                      }
                      {workshop.stagename === "Awaiting AMMD Approval" &&
                        <img src={Waiting} style={{ width: '30px', paddingLeft: '10px' }} />
                      }
                      {workshop.stagename === "AMMD Confirmation" &&
                        <img src={Confirm} style={{ width: '30px', paddingLeft: '10px' }} />
                      }
                      {workshop.stagename === "Execution" &&
                        <img src={Execution} style={{ width: '35px', paddingLeft: '10px' }} />
                      }
                      {workshop.stagename === "CMDI Verification" &&
                        <img src={Verified} style={{ width: '30px', paddingLeft: '10px' }} />
                      }
                      {workshop.stagename === "Paid" &&
                        <img src={Confirm} style={{ width: '30px', paddingLeft: '10px' }} />
                      }
                      {workshop.stagename === "Cancelled" &&
                        <img src={Cancelled} style={{ width: '30px', paddingLeft: '10px' }} />
                      }
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            
          );
       
      })
    ) : (
        <Grid container spacing={8} justify="center" alignItems="center">
          <Grid item>
            <Typography align="center" variant="h6">
              No Record Present
        </Typography>
          </Grid>
        </Grid>
      )}
  </List>
  );
});


class ListWorkshopsAMMD extends React.Component {
  constructor(props) {
    super(props);
    const cmdiFilt = this.props.location.state ? this.props.location.state.cmdiFilter : "All";
    const fcpFilt = this.props.location.state ? this.props.location.state.fcpFilter : "All";
    const stageFil = this.props.location.state ? this.props.location.state.stageFilter : "All";
    this.state = {
      value: 0,
      loading: true,
      workshops: [],
      cmdiNameList: [{name: "All"}],
      fcpNameList: [{name: "All"}],
      cmdiFilter: cmdiFilt,
      fcpFilter: fcpFilt,
      stageFilter: stageFil,
      ApprovedList: [],
      AwaitingList: [],
    };
  }

  async componentDidMount() {
    await client
      .query({
        query: gql(getUser)
      })
      .then(({ data }) => {
        if (data.user.role === "AMMD") {
          this.setState({
            userData: data.user
          });
        }
      });
    if (this.state.userData && this.state.userData.sfid) {
      const cmdiList = await getData(`SELECT SFId, Id, Name, Type__c, Email__c, Reporting_To_AMMD__c, MDIcode__c FROM salesforce.Pidilite_User__c Where Reporting_To_AMMD__c = '${this.state.userData.sfid}'`)
      cmdiList.result.map(list => this.state.cmdiNameList.push({name: list.name}))
      console.log("cmdiNameList", this.state.cmdiNameList)

      const fcpList = await getData(`Select Distinct(FCPName__c) from salesforce.Opportunity Where (StageName='AMMD Confirmation' or StageName='Execution' or StageName='CMDI Verification') And assigned_ammd__c = '${this.state.userData.sfid}'`)
      fcpList.result.map(list => this.state.fcpNameList.push({name: list.fcpname__c}))
      console.log("fcpNameList", this.state.fcpNameList)

      const { result: [ammdData] } = await getData(`select * from salesforce.Pidilite_User__c where sfid='${this.state.userData.sfid}'`)
      const newSFID = this.state.userData.sfid
      console.log("ammdData", ammdData)

      const workshopData = await getData(`Select * from salesforce.Opportunity Where (StageName='AMMD Confirmation' or StageName='Execution' or StageName='CMDI Verification') And assigned_ammd__c = '${newSFID}'`)
      this.setState({ workshops: workshopData.result, loading: false })
      console.log("workshopData", workshopData)
      
      // const AwaitingList = this.state.workshops.filter( workshop =>
      //   workshop.stagename === "AMMD Confirmation"
      // );
      const ApprovedList = this.state.workshops.filter( workshop =>
        workshop.stagename === "Execution" || workshop.stagename === "CMDI Verification" 
      );
      const sortedList = ApprovedList.sort((a,b) => new Date(b.createddate) - new Date(a.createddate));
      this.setState({ ApprovedList: sortedList});

      const cmdiFilt = this.props.location.state ? this.props.location.state.cmdiFilter : "All";
      const fcpFilt = this.props.location.state ? this.props.location.state.fcpFilter : "All";
      const stageFil = this.props.location.state ? this.props.location.state.stageFilter : "All";
      this.handleFilterCMDI(cmdiFilt);
      this.handleFIlterFCP(fcpFilt);
      this.handleFilterStage(stageFil);

      // Promise.all([
      //   getData(
      //     `Select * from salesforce.Opportunity Where (StageName='AMMD Confirmation' or StageName='Execution' or StageName='CMDI Verification') And assigned_ammd__c = '${newSFID}' `
      //   )
      // ]).then(([workshopsData, ...data]) => {
      //   this.setState({
      //     workshops: workshopsData.result,
      //     loading: false
      //   });
      // });
    }
  }

  handleChange = (event, value) => {
    console.log("HandleCHange Fuc() ")
    this.setState({ value });
    this.handleFilterCMDI("All");
    this.handleFIlterFCP("All");
    this.handleFilterStage("All");
    this.setState({ cmdiFilter: "All", fcpFilter: "All", stageFilter: "All" })
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };
 
  handleFilterCMDI = (cmdi) => {
    console.log("cmdi => ",cmdi)
    console.log(" this.state.stageFilter => ", this.state.stageFilter)

    this.setState({ cmdiFilter: cmdi })
    const filteredList = this.state.workshops.filter(workshop =>
      cmdi === "All" 
        ? this.state.fcpFilter === "All"
          ? this.state.stageFilter === "All"
            ? this.state.value === 0
              ? workshop.stagename === "AMMD Confirmation"
              : (workshop.stagename === "Execution" || workshop.stagename === "CMDI Verification") 
            : (workshop.stagename === this.state.stageFilter)
          : this.state.stageFilter === "All"
            ? this.state.value === 0
              ? (workshop.fcpname__c === this.state.fcpFilter && workshop.stagename === "AMMD Confirmation")
              : (workshop.fcpname__c === this.state.fcpFilter && (workshop.stagename === "Execution" || workshop.stagename === "CMDI Verification") )
            : (workshop.fcpname__c === this.state.fcpFilter && workshop.stagename === this.state.stageFilter)
        : this.state.fcpFilter === "All"
          ? this.state.stageFilter === "All" 
            ? this.state.value === 0 
              ? (workshop.cmdi_name__c === cmdi && workshop.stagename === "AMMD Confirmation")
              : (workshop.cmdi_name__c === cmdi && (workshop.stagename === "Execution" || workshop.stagename === "CMDI Verification"))
            : (workshop.stagename === this.state.stageFilter && workshop.cmdi_name__c === cmdi) 
          : this.state.stageFilter === "All" 
            ? this.state.value === 0 
              ? (workshop.cmdi_name__c === cmdi && workshop.fcpname__c === this.state.fcpFilter && workshop.stagename === "AMMD Confirmation")
              : (workshop.cmdi_name__c === cmdi && workshop.fcpname__c === this.state.fcpFilter && (workshop.stagename === "Execution" || workshop.stagename === "CMDI Verification"))
            : (workshop.cmdi_name__c === cmdi && workshop.fcpname__c === this.state.fcpFilter && workshop.stagename === this.state.stageFilter) 
    );

    const sortedList = filteredList.sort((a,b) => new Date(b.createddate) - new Date(a.createddate));
    this.state.value === 0 
    ? this.setState({ AwaitingList: sortedList })
    : this.setState({ ApprovedList: sortedList });
  };

  handleFilterStage = (stage) => {
    console.log("stage => ",stage)
    this.setState({ stageFilter: stage })
    const filteredList = this.state.workshops.filter(workshop =>
      stage === "All" 
        ? this.state.fcpFilter === "All" 
          ? this.state.cmdiFilter === "All"
            ? this.state.value === 0
              ? workshop.stagename === "AMMD Confirmation"
              : workshop.stagename === "Execution" || workshop.stagename === "CMDI Verification" 
            : this.state.value === 0
              ? (workshop.cmdi_name__c === this.state.cmdiFilter && workshop.stagename === "AMMD Confirmation")
              : (workshop.cmdi_name__c === this.state.cmdiFilter && (workshop.stagename === "Execution" || workshop.stagename === "CMDI Verification") ) 
          : this.state.cmdiFilter === "All"
            ? this.state.value === 0
              ? (workshop.fcpname__c === this.state.fcpFilter && workshop.stagename === "AMMD Confirmation")
              : (workshop.fcpname__c === this.state.fcpFilter && (workshop.stagename === "Execution" || workshop.stagename === "CMDI Verification") )
            : this.state.value === 0
              ? (workshop.fcpname__c === this.state.fcpFilter && workshop.cmdi_name__c === this.state.cmdiFilter && workshop.stagename === "AMMD Confirmation")
              : (workshop.fcpname__c === this.state.fcpFilter && workshop.cmdi_name__c === this.state.cmdiFilter && (workshop.stagename === "Execution" || workshop.stagename === "CMDI Verification") )
        : this.state.fcpFilter === "All" 
          ? this.state.cmdiFilter === "All"
            ? workshop.stagename === stage 
            : (workshop.cmdi_name__c === this.state.cmdiFilter && workshop.stagename === stage)
          : this.state.cmdiFilter === "All"
            ? (workshop.fcpname__c === this.state.fcpFilter && workshop.stagename === stage )
            : (workshop.fcpname__c === this.state.fcpFilter && workshop.cmdi_name__c === this.state.cmdiFilter && workshop.stagename === stage)
    );
    const sortedList = filteredList.sort((a,b) => new Date(b.createddate) - new Date(a.createddate));
    this.state.value === 0 
    ? this.setState({ AwaitingList: sortedList })
    : this.setState({ ApprovedList: sortedList })
  };

  handleFIlterFCP = (fcp) => {
    console.log("fcp => ", fcp);
    this.setState({ fcpFilter: fcp });
    const filteredList = this.state.workshops.filter(workshop =>
      fcp === "All"
      ? this.state.cmdiFilter === "All"
        ? this.state.stageFilter === "All"
          ? this.state.value === 0
            ? workshop.stagename === "AMMD Confirmation"
            : workshop.stagename === "Execution" || workshop.stagename === "CMDI Verification" 
          : workshop.stagename === this.state.stageFilter
        : this.state.stageFilter === "All"
          ? this.state.value === 0
            ? (workshop.cmdi_name__c === this.state.cmdiFilter && workshop.stagename === "AMMD Confirmation")
            : (workshop.cmdi_name__c === this.state.cmdiFilter && (workshop.stagename === "Execution" || workshop.stagename === "CMDI Verification") )
          : (workshop.cmdi_name__c === this.state.cmdiFilter && workshop.stagename === this.state.stageFilter)
      : this.state.cmdiFilter === "All"
        ? this.state.stageFilter === "All"
          ? this.state.value === 0
            ? (workshop.fcpname__c === fcp && workshop.stagename === "AMMD Confirmation")
            : (workshop.fcpname__c === fcp && (workshop.stagename === "Execution" || workshop.stagename === "CMDI Verification" ) )
          : (workshop.fcpname__c === fcp && workshop.stagename === this.state.stageFilter)
        : this.state.stageFilter === "All"
          ? this.state.value === 0
            ? (workshop.fcpname__c === fcp && workshop.cmdi_name__c === this.state.cmdiFilter && workshop.stagename === "AMMD Confirmation")
            : (workshop.fcpname__c === fcp && workshop.cmdi_name__c === this.state.cmdiFilter && (workshop.stagename === "Execution" || workshop.stagename === "CMDI Verification") )
          : (workshop.fcpname__c === fcp && workshop.cmdi_name__c === this.state.cmdiFilter && workshop.stagename === this.state.stageFilter )
      );

    const sortedList = filteredList.sort((a,b) => new Date(b.createddate) - new Date(a.createddate));
    this.state.value === 0 
    ? this.setState({ AwaitingList: sortedList })
    : this.setState({ ApprovedList: sortedList })
  }

  handleSorting = (sortIn) => {
    let list = this.state.value === 0 ? this.state.AwaitingList : this.state.ApprovedList;
    let sortedList;
    if(sortIn === "asc")
    sortedList = list.sort((a,b) => new Date(a.createddate) - new Date(b.createddate));
    else
    sortedList = list.sort((a,b) => new Date(b.createddate) - new Date(a.createddate));

    this.state.value === 0 
    ? this.setState({ AwaitingList: sortedList })
    : this.setState({ ApprovedList: sortedList })
  }

  render() {
    const { classes, history } = this.props;
    const { value } = this.state;
    // const ApprovedList = _.filter(
    //   this.state.workshops,
    //   workshop =>
    //     workshop.stagename === "Execution" || workshop.stagename === "CMDI Verification" 
    // );
    // const AwaitingList = _.filter(this.state.workshops, {
    //   stagename: "AMMD Confirmation"
    // });
    return (
      <div>
        <AppBar position="static">
          <Toolbar>
            <IconButton 
              className={classes.menuButton}
              color="inherit"
              aria-label="Menu"
              onClick={() => {
                // history.goBack();
                history.push({pathname: "/homeAMMD"})
              }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography
              variant="title"
              color="inherit"
              className={classes.flex}
            >
              Workshops
            </Typography>
          </Toolbar>
        </AppBar>
        {/* style={{position: "fixed", width:"100%", zIndex:1}}        */}
        <Paper> 
          <Tabs
            value={this.state.value}
            onChange={this.handleChange} 
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab label={`Awaiting Approval (${this.state.AwaitingList.length})`} />
            <Tab label={`Approved (${this.state.ApprovedList.length})`} />            
          </Tabs>
        </Paper>
        <Paper>
          <Divider />
          <Grid container spacing={10} padding="50px" alignItems="center">
            <Grid item xs={3}>
              <Typography component="span" style={{ paddingLeft: 50, padding: 10}}>
                <Select
                  name="cmdiName"
                  placeholder="CMDI Name"
                  onChange={(e) => this.handleFilterCMDI(e.value) }
                  value={this.state.cmdiFilter ? {label: this.state.cmdiFilter} : null}
                  options={this.state.cmdiNameList.map(cmdiName => ({
                      value: cmdiName.name, label: cmdiName.name
                  }))}
                />
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography component="span" style={{ paddingLeft: 50, padding: 10}}>
                <Select
                  name="fcpName"
                  placeholder="FCP Name"
                  onChange={(e) => this.handleFIlterFCP(e.value) }
                  value={this.state.fcpFilter ? {label: this.state.fcpFilter} : null}
                  options={this.state.fcpNameList.map(fcpName => ({
                      value: fcpName.name, label: fcpName.name
                  }))}
                />
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography component="span" style={{ paddingRight: 50, padding: 10}}>
                <Select
                    name="stageName"
                    placeholder="Stage Name"
                    onChange={(e) => this.handleFilterStage(e.value) }
                    value={this.state.stageFilter ? {label: this.state.stageFilter} : null}
                    options={this.state.value === 0 ?
                      [ {value: "All", label: "All"},
                        {value: "AMMD Confirmation", label: "AMMD Confirmation"}]
                    : [ {value: "All", label: "All"},
                        {value: "Execution", label: "Execution"},
                        {value: "CMDI Verification", label: "CMDI Verification"}
                      ]}
                  />
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography component="span" style={{ paddingRight: 50, padding: 10}}>
                <Select
                    name="sortby"
                    placeholder="Sort By"
                    onChange={(e) => this.handleSorting(e.value) }
                    options={[
                        {value: "asc", label: "asc"},
                        {value: "desc", label: "desc"}
                      ]}
                  />
              </Typography>
            </Grid>
          </Grid>
          <Divider />
        </Paper>

        {this.state.loading ? (
          <Grid container alignItems="center" justify="center">
            <Loader type="Audio" color="#00BFFF" height="50" width="50" />
          </Grid>
        ) : (
          <SwipeableViews
            index={this.state.value}
            onChangeIndex={this.handleChangeIndex}
          >
            <RederWorkshopList workshops={this.state.AwaitingList} filterState= {this.state}/>
            <RederWorkshopList workshops={this.state.ApprovedList} filterState= {this.state}/>            
          </SwipeableViews>            
          )}
      </div>
    );
  }
}
export default withRouter(withStyles(styles)(ListWorkshopsAMMD));
